module.exports = __webpack_public_path__ + "img_left_side--right.9a2ae53827a6dcd4f21a264f63c1a2d8.png";